import { loadDataFeedCompatibleDataSets } from 'js/actions';
import { loadByType, selectorsByType } from 'new/elements/ResourceSelectionButton/consts';
import { useDispatch, useSelector } from 'react-redux';

export default function useListingItems(
  resourceType: string,
  dataFeedCompatible = false,
): {
  data: any[];
  loadData: () => Promise<any>;
} {
  const selector = selectorsByType[resourceType];
  const data = useSelector(selector) as any[];
  const dispatch = useDispatch();
  const loadDataFn = dataFeedCompatible ? loadDataFeedCompatibleDataSets : loadByType[resourceType];

  const loadData = (...args) => {
    return dispatch(loadDataFn(...args));
  };

  return { data, loadData };
}
